export const TOKEN = "Token";

export class CookieHandler {
  static setToken(token: string) {
    this.setCookie(TOKEN, token, 1);
  }

  static setTokenByKey(key: string, token: string, time: number = 24) {
    this.setCookie(key, token, time);
  }

  static getToken(): string {
    return this.getCookie(TOKEN);
  }

  static getTokenByKey(key: string): string {
    return this.getCookie(key);
  }

  static removeToken() {
    this.eraseCookie(TOKEN);
  }
  static removeTokenByKey(key: string) {
    this.eraseCookie(key);
  }

  private static setCookie(name: string, value: string, hours = 24) {
    let expires = "";
    if (hours) {
      let date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  private static getCookie(name: string): string {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
  }

  private static eraseCookie(key: string): void {
    document.cookie =
      key + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
